/** Existing Footer Management `app_download` payload → player download URL. */

export const APP_DOWNLOAD_PATH = '/download/apk';
export const DEFAULT_APP_DOWNLOAD_TITLE = 'Casino App — Download';

export function shouldShowAppDownloadPromo(appDownload) {
  return !!(appDownload && typeof appDownload === 'object');
}

export function resolveAppDownloadTitle(appDownload) {
  const title = String(appDownload?.title || '').trim();
  return title || DEFAULT_APP_DOWNLOAD_TITLE;
}

export function resolveAppDownloadUrl(appDownload) {
  const raw = String(appDownload?.androidAppUrl || '').trim();
  if (!raw) return APP_DOWNLOAD_PATH;
  if (raw.startsWith('/') && !raw.startsWith('//')) {
    return raw === '/download/apk/' ? APP_DOWNLOAD_PATH : raw;
  }
  try {
    const parsed = new URL(raw);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return APP_DOWNLOAD_PATH;
    }
    const path = parsed.pathname.replace(/\/+$/, '') || '/';
    if (path === APP_DOWNLOAD_PATH) return APP_DOWNLOAD_PATH;
    return parsed.href;
  } catch {
    return APP_DOWNLOAD_PATH;
  }
}
